import React, { Component } from 'react'
import { connect } from 'react-redux'
import compose from 'lodash/fp/compose'

import errorBoundary from 'client/shared/decorators/error-boundary'
import bookHelper from 'shared/tools/book-helper'

import BookStatus from 'client/shared/blocks/book-status'

import { getLibraryCardById } from 'client/bookmate/reducers/library-cards-reducer'
import { LibraryCardProps } from 'client/shared/types/library-card'
import { ResourceName } from 'client/shared/types/resource'
import { State } from 'shared/types/redux'

type Props = {
  isContentHidden?: boolean
  libraryCard: LibraryCardProps
  resourceType: ResourceName
}

class LibraryCardStatusBox extends Component<Props> {
  render(): JSX.Element | null {
    const { libraryCard, resourceType, isContentHidden } = this.props

    return libraryCard ? (
      <BookStatus
        progress={
          bookHelper.inProgress(libraryCard) ? libraryCard.progress : null
        }
        isFinished={bookHelper.isFinished(libraryCard)}
        isPrivate={bookHelper.isPrivate(libraryCard)}
        isSerial={resourceType === 'serial'}
        isContentHidden={isContentHidden}
      />
    ) : null
  }
}

const connectWrapper = connect(
  (state: State, ownProps: { resourceType: ResourceName }) => ({
    libraryCard: getLibraryCardById(
      state,
      state[ownProps.resourceType].library_card_uuid,
    ),
  }),
)

const wrappers = compose(connectWrapper, errorBoundary)

export default wrappers(LibraryCardStatusBox)
